// extracted by mini-css-extract-plugin
export default {"itemsGap":"8px","searchQueries":"SearchQuery-module__searchQueries--a4466","query":"SearchQuery-module__query--fc3a0","last":"SearchQuery-module__last--c337f"};